import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { EXTENDED_CHART_TYPES, VIEWS } from '../../constants';
import { setChartView, setChartViewGroup } from '../../redux/sonar/sonarActions';
import CommonDropdown from '../../components/common-dropdown/CommonDropdown';
import CommonRadioGroup from '../../components/common-radio-group/CommonRadioGroup';
import { getViewForChart, getViewGroupForChart } from '../../redux/sonar/sonarSelectors';

import scss from './ExtendedViewToolbar.module.scss';

function ExtendedViewToolbar({ children, chartIndex, section, viewOptions, allowGroupsFilter, disableChartTypes }) {
  const { t } = useTranslation('sonar');
  const dispatch = useDispatch();

  const [chartType, setChartType] = useState(EXTENDED_CHART_TYPES.BUBBLES);
  const view = useSelector(getViewForChart(section, chartIndex));
  const group = useSelector(getViewGroupForChart(section, chartIndex));
  const groupEntries = useSelector((state) => state.sonarDashboard.groupEntries);

  const groupOptions = [
    { value: 'ALL', label: t('all') },
    ...groupEntries.map(({ domain }) => ({ value: domain, label: domain })),
  ];

  const chartTypeOptions = [
    {
      value: EXTENDED_CHART_TYPES.BUBBLES,
      label: t('bubbles'),
    },
    {
      value: EXTENDED_CHART_TYPES.SCATTER,
      label: t('scatter'),
    },
  ];

  const handleChangeView = (newView) => {
    dispatch(setChartView({ section, index: chartIndex, view: newView }));
  };

  const handleChangeGroup = (newGroup) => {
    dispatch(setChartViewGroup({ section, index: chartIndex, group: newGroup }));
  };

  return (
    <>
      <div className={scss.wrapper}>
        {!disableChartTypes ? (
          <CommonRadioGroup value={chartType} onChange={setChartType} options={chartTypeOptions} />
        ) : null}

        <CommonDropdown options={viewOptions} onSelect={handleChangeView} value={view} maxWidth={170} />

        {view === VIEWS.GROUPS && allowGroupsFilter ? (
          <CommonDropdown
            options={groupOptions}
            onSelect={handleChangeGroup}
            value={group}
            maxWidth={170}
            isFilterable
          />
        ) : null}
      </div>
      <div className={scss.content}>{children({ chartType })}</div>
    </>
  );
}

export default ExtendedViewToolbar;
